// MainStyles.js
import { createGlobalStyle } from 'styled-components';

export const MainStyles = createGlobalStyle`

    body {
      margin: 0;
      font-family: ${(props) => props.fontFamily};
      font-weight: 400;
      display: flex;
      flex-direction: column;
    }

    ::selection {
        background: ${(props) => props.selectionBackground};
        color: ${(props) => props.selectionForeground};
    }

    input::selection, textarea::selection {
      background: ${(props) => props.selectionBackground};
      color: ${(props) => props.selectionForeground};
    }

    input::-moz-selection, textarea::-moz-selection {
      background: ${(props) => props.selectionBackground};
      color: ${(props) => props.selectionForeground};
    }
    
`;

